export const BUILD_VERSION = '1793779792';
